ux-iws-sf-sidebar {
    --menu-item-background-color: transparent;

    display: block;
    position: relative;
    pointer-events: auto;
    transform: translateX(-100%);
    width: 100%;
    height: 100%;
    z-index: 1;

    &[opened] {
        transform: none;
    }

    &[data-animated] {
        transition: transform 0.3s ease-out;
    }

    @media (min-width: 568px) {
        width: 384px;
    }

    @media (min-width: 768px) {
        width: 300px;
        z-index: auto;
    }

    header {
        display: block;
        width: 100%;
        box-sizing: border-box;
        padding: 60px 30px 30px;
        color: #000;

        @media (min-width: 768px) {
            padding: 80px 40px 50px;
        }
    }

    h1,
    h2,
    h3,
    h4,
    h5 {
        @include font(light);
        font-size: 23px;
        line-height: 1.2;
        color: currentColor;
        margin: 0;

        @media (min-width: 768px) {
            font-size: 34px;
        }
    }

    nav {
        display: block;
        width: 100%;
    }

    .ux-iws-sf-sidebar__inner {
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: stretch;
        justify-content: flex-start;
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        padding: 0 0 60px;
        margin: 0;
        background:
            linear-gradient(90deg, #eff0f4 0%, rgba(239, 240, 244, 0.6) 100%),
            linear-gradient(0deg, #fff 0%, #fff 100%);
        z-index: 1;

        @media (min-width: 768px) {
            padding-bottom: 100px;
        }
    }

    .ux-iws-sf-sidebar__close,
    .ux-iws-sf-sidebar__tab {
        appearance: none;
        border: 0 none;
        background: transparent;
        border-radius: 0;
        padding: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        cursor: pointer;
    }

    .ux-iws-sf-sidebar__tab {
        background-color: $color_green;
        color: #fff;
        top: 15px;
        left: 100%;
        width: 54px;
        height: 54px;
        transition: transform 0.3s ease-out;

        ux-icon {
            font-size: 30px;
        }
    }

    .ux-iws-sf-sidebar__close {
        color: #000;
        top: 15px;
        right: 10px;
        width: 54px;
        height: 54px;

        ux-icon {
            font-size: 12px;
        }
    }

    &[fixed] {
        position: fixed;
        top: 0;
        left: 0;
        height: 100%;
        z-index: 1000;
    }
}

@media (max-width: 567px) {
    ux-iws-sf-sidebar[opened] .ux-iws-sf-sidebar__tab {
        transform: translateX(-100%);
    }
}
